<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <BaseFieldString
            v-model="storeAggregate.rootData[storeDetail.uidItem].name"
            label="Name"
        ></BaseFieldString>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";

export default {
  name: "SimpleChildDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'SimpleChildDetail'},
    dtoDetailQuery: {default: 'SimpleChildDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SimpleChildActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SimpleChildSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'SimpleChildValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'SimpleChildMainBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'SimpleChildTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldString,
    CommonDetail,
  },

  methods: {},


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  },
}
</script>

<style scoped>

</style>